import React, { useEffect, useState } from "react";
import { Modal, Button } from "react-bootstrap";

const ShareLinkModal = ({ show, onClose, onCreateLink, link }) => {
  const [copied, setCopied] = useState(false);

  // Handle copy action
  const handleCopy = () => {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard
        .writeText(link)
        .then(() => {
          setCopied(true);
          onCreateLink?.();
          setTimeout(() => setCopied(false), 1500); // Reset after 1.5 seconds
        })
        .catch((err) => {
          console.error("Clipboard API failed", err);
          fallbackCopy(link);
          setCopied(true);
          setTimeout(() => setCopied(false), 1500); // Reset after 1.5 seconds
        });
    } else {
      fallbackCopy(link);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500); // Reset after 1.5 seconds
    }
  };

  // Fallback for older browsers
  const fallbackCopy = (text) => {
    const textarea = document.createElement("textarea");
    textarea.value = text;
    textarea.style.position = "fixed";
    textarea.style.top = "-9999px";
    document.body.appendChild(textarea);
    textarea.focus();
    textarea.select();

    try {
      const successful = document.execCommand("copy");
      if (successful) {
        onCreateLink?.();
      }
    } catch (err) {
      console.error("Fallback copy failed", err);
    }

    document.body.removeChild(textarea);
  };

  // Cleanup timeout on component unmount
  useEffect(() => {
    return () => {
      setCopied(false); // Reset copied state on unmount
    };
  }, []);

  return (
    <Modal
      show={show}
      onHide={onClose}
      centered
      backdrop="static"
      keyboard={true}
      dialogClassName="custom-modal-dialog"
    >
      <Modal.Body className="text-white p-4 rounded-4 !pb-[16px] pt-[26px]">
    
        <p className="text-gray-600 text-center flex items-center justify-center p-[1px]">
          <img
            src="https://jobcritics.com/assets/img/biar/ratings.webp"
            alt="Delete"
            className="w-[150px] mr-2"
          />
        </p>
        <h6 className="font-semibold text-black text-center w-full mb-0 mt-[6px] pb-[5px]">Invite Connections!</h6>
        <p className="text-gray-600 text-center text-[17px] leading-[1.6] pb-[15px]">
          Share this link with colleagues/friends to enhance your professional credibility.
        </p>

        <div className="grid mt-6 w-full gap-3 w-full justify-center">
          <Button
            onClick={handleCopy}
            className={` ${copied
              ? "btn-explore-yellow-disabled !border-gray-300 !border-[1px] disabled:!cursor-not-allowed disabled:!bg-gray-300 disabled:opacity-50 disabled:hover:!border-gray-300 disabled:hover:!bg-gray-300 disabled:!text-gray-900 disabled:hover:!text-gray-900 text-c pd3 !w-[300px]"
              : "btn-explore-yellow text-c pd3 !w-[300px]"
              }`}
            disabled={copied}
          >
            {copied ? "Copied!" : "🔗 Copy link"}
          </Button>
          <p
            className="text-gray-700  hover:text-base hover:bg-gray-200 hover:rounded-[24px] cursor-pointer text-center text-c !p-[8px] !w-[300px] "
            onClick={onClose}
          >
            CLOSE
          </p>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ShareLinkModal;